
































import Vue from 'vue';
import { Action } from 'vuex-class';
import Component from 'vue-class-component';
import { AuthService } from '../../services/authService';

@Component({})
export default class Login extends Vue {
  authService = new AuthService();
  @Action('setUser', { namespace: 'auth' }) setUser: any;

  async created() {
    this.setUser(null);
    const accounts = await this.authService.getAllAccountsAsync();

    !!accounts.length && this.$router.push({ name: 'Home' }).then(() => location.reload());
  }

  async tryLogin(): Promise<any> {
    try {
      const response = await this.authService.loginAsync();

      if (response) this.$router.push({ name: 'Home' }).then(() => location.reload());
    } catch (error) {
      console.log('login: tryLogin()', error);
      await this.cancelLogin();
    }
  }

  async cancelLogin(): Promise<void> {
    sessionStorage.clear();
    localStorage.clear();
    document.cookie.split(';').forEach(function(c) {
      document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
    await this.authService.logoutAsync();
  }
}
